import styled from 'styled-components/macro';

import { sizes } from '../../../styles/vars';

const WidgetContent = styled.div`
  margin: ${sizes.blockPaddingY} 0;
`;

export default WidgetContent;
